// assets/landing-caletilla.js

document.addEventListener('DOMContentLoaded', () => {

    // --- 1. Variables de Control (en segundos) ---
    const fadeDuration = 2.5; 
    const visibleDurations = [
        2, // Duración para la imagen 1 (logo)
        10, // Duración para la imagen 2 (txt-01)
        10, // Duración para la imagen 3 (txt-02)
        7, // Duración para la imagen 4 (logo)
        10, // Duración para la imagen 5 (txt-03)
        10, // Duración para la imagen 6 (txt-04)
        7, // Duración para la imagen 7 (logo)
        15, // Duración para la imagen 8 (txt-05)
        7, // Duración para la imagen 9 (Una-silla-para-todos)
        10, // Duración para la imagen 10 (txt-06)
        10  // Duración para la imagen 11 (txt-07)
    ];

    // --- 2. Elementos y Datos ---
    const imgElement = document.getElementById('txt-svg_asset');
    
    // ----- ¡AQUÍ ESTABA EL ERROR! -----
    // Esta es tu lista de URLs correcta, sin la 'Y' mayúscula.
    const imageUrls = [
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_logo.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-01.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-02.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_logo.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-03.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-04.svg?v=1762546954",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_logo.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-05.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_Una-silla-para-todos.svg?v=1762533974",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-06.svg?v=1762543985",
        "https://cdn.shopify.com/s/files/1/0720/1511/8591/files/HazlaTuya_txt-07.svg?v=1762543985"
    ];

    // Verificación
    if (!imgElement) {
        console.error('Elemento "txt-svg_asset" no encontrado.');
        return;
    }
    if (imageUrls.length !== visibleDurations.length) {
        console.error('Error: La cantidad de URLs no coincide con la cantidad de duraciones.');
        return;
    }
    
    // --- 3. Configuración de GSAP ---
    
    // Empezamos con opacidad 0, como sugeriste.
    gsap.set(imgElement, { opacity: 0 });

    const tl = gsap.timeline({
        repeat: -1 // Repetir para siempre
    });

    // --- 4. Construir la Secuencia de Animación (Lógica correcta) ---
    
    // Iteramos sobre CADA elemento (índice 0 al 10)
    imageUrls.forEach((url, i) => {
        
        // 1. Cambio: Pone la imagen (mientras la opacidad es 0)
        tl.set(imgElement, {
            attr: { src: url }
        });

        // 2. Fade In: Muestra la imagen
        tl.to(imgElement, {
            opacity: 1,
            duration: fadeDuration,
            ease: "power1.out"
        });

        // 3. Pausa: Mantiene la imagen visible
        tl.to(imgElement, {
            duration: visibleDurations[i],
            ease: "none"
        });

        // 4. Fade Out: Oculta la imagen, preparándose para la siguiente
        tl.to(imgElement, {
            opacity: 0,
            duration: fadeDuration,
            ease: "power1.in"
        });
    });
});